<template>
  <!-- Manage Comapny List -->
  <div class="page-layout blank contacts-manage">
    <!-- <div v-if="showIllustrator">
            <div class="row" style="height: 100%;width: 100%;">
                <div class="col-lg-12 text-center py-3 px-3 mt-10">
                    <div class="flex-container">
                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                    </div>
                </div>
            </div>
    </div>-->
    <div class="pb-10">
      <h2 class="headerblock py-0">
        <div class="row d-flex justify-content-between align-items-center px-5">
          <!-- <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                        <div class="breadcome-heading">
                            <div class="form-group formsearch has-warning has-feedback">
                                <input type="text" class="form-control textremove holder" id="inputWarning2" aria-describedby="inputWarning2Status" placeholder="Search...">
                                <span class="icon-close-circle-outline form-control-feedback-cancel" aria-hidden="true" ></span>
                                <span class="icon-magnify iconsearch form-control-feedback" aria-hidden="true"></span>
                            </div>
                        </div>
                        <router-link
                            :disabled="!$routerHistory.hasForward()"
                            :to="{ path: $routerHistory.next().path }">
                            <el-tooltip class="item pull-right" effect="dark" content="Click to Go Forward" placement="top">
                                <button class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-right"></i>
                                </button>
                            </el-tooltip>
                        </router-link>
                        <router-link
                            :disabled="!$routerHistory.hasPrevious()"
                            :to="{ path: $routerHistory.previous().path }">
                            <el-tooltip class="item pull-right" effect="dark" content="Click to Go Back" placement="top">
                                <button class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-left"></i>
                                </button>
                            </el-tooltip>
                        </router-link>
          </div>-->
          <!-- <div class="col-lg-6 col-md-5 col-sm-5 col-xs-12"> -->
          <div class="breadcrumbnew">
            <span>List View</span>
          </div>
          <!-- </div> -->
          <!-- <div class="col-lg-6 col-md-5 col-sm-5 col-xs-12"> -->
          <button
            type="button"
            class="btn btn-new-green btn-wide mr-2"
            style="box-shadow: none;"
            @click="accountSetup()"
          >+ Create New</button>
          <!-- </div> -->
        </div>
      </h2>

      <div class="page-layout carded left-sidebar" style="overflow-y: visible;">
        <div class="page-content-wrapper" style="border-radius: 15px;background-color: #d6e2ef;">
          <div
            class="page-content custom-scrollbar"
            style="border-radius: 15px;background-color: #d6e2ef !important;"
          >
            <div class="tabs-content-firstblock">
              <div class="row">
                <div class="col-lg-12">
                  <div class="preview-elements adminview">
                    <div class>
                      <div
                        class="page-header-search text-center row no-gutters align-items-center justify-content-between"
                        style="height: 0rem;min-height: 0rem;max-height: 0rem;"
                      >
                        <!-- <div class="col search-wrapper fs-16 fw-600" style="color: #303031;font-size: 16px;">
                                                    Manage Your Account
                        </div>-->
                      </div>
                      <!-- <ul class="list-group dense managecompanyheader mt-5 mb-2">
                                                <li class="list-group-item three-line" style="background-color: transparent !important;">
                                                    <div class="avatar avatar-header" v-if="isBusinessAccount">
                                                        <img :src="selectedCompany.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'">
                                                    </div>
                                                    <div class="avatar avatar-header" v-else>
                                                        <img :src="loggedInUser.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'">
                                                    </div>
                                                    <div class="list-item-content">
                                                        <h3 v-if="!isBusinessAccount">{{loggedInUser.full_name}}</h3>
                                                        <h4 v-if="isBusinessAccount" style="font-size: 14px;color: #4e5764;line-height: 1.21;letter-spacing: 0.6px;font-weight: 600;">
                                                            {{selectedCompany.email_id}}<br>
                                                            <span style="font-size: 14px;color: #4e5764;line-height: 1.21;letter-spacing: 0.6px;font-weight: 500;margin-top: 3px;">{{selectedCompany.company_name}}</span>
                                                        </h4>
                                                        <h4 v-else>
                                                            {{loggedInUser.login_id}}
                                                            (default)
                                                        </h4>
                                                        <button type="button" class="btn btn-secondary btn-smm btn-log" @click="logout()">
                                                            Logout
                                                        </button>
                                                    </div>
                                                </li>
                                            </ul>
                                            <a class="btn btn-link btn-personal mb-4 ml-3" style="font-size: 16px !important;" v-if="isBusinessAccount" @click="switchAccount(null, null)">
                                                Switch to Personal Account
                      </a>-->
                    </div>
                    <!-- <div class="row">
                                            <div class="col-lg-12 text-center py-3 px-3">
                                                <img src="/static/images/crm/divider.svg" class="img-fluid">
                                            </div>
                    </div>-->
                    <div class="businessHeader ml-2 mr-1 mt-4">
                      <div class="descriptionheader">
                        <div class="description-text-header-left">
                          <h5>Linked Companies</h5>
                        </div>
                        <!-- <div class="description-text-header-right" v-if="allAccounts.length">
                                                    <div class="dropdown mr-3">
                                                        <el-tooltip class="item" effect="dark" content="Search Employess" placement="bottom">
                                                            <div class="dropdown-toggle employee-toggle pointer btn btn-link hidden-sm-down" role="button" id="dropdownShortcutMenu" data-toggle="dropdown" aria-haspopup="true" style="padding: 0px;min-width:1.4rem;">
                                                                <i class="icon crmnew-search-round searchContentEmployee"></i>
                                                            </div>
                                                        </el-tooltip>
                                                        <div class="dropdown-menu dropdown-employee-search" aria-labelledby="dropdownShortcutMenu">
                                                            <section>
                                                                <div class="px-4">
                                                                    <div class="">
                                                                        <div class="form-group">
                                                                            <div class="input-search-rounded-box-employee">
                                                                                <i class="input-search-icon icon-magnify defaultBlue" aria-hidden="true"></i>
                                                                                <input type="text" class="form-control" name="search_key"  placeholder="Search Employee Name or Designation">
                                                                                <button type="button" class="input-search-close icon icon-close-circle" aria-label="Close"></button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="py-2 px-4 employeeSearchResult">
                                                                            <div class="contact row pointer text-center" style="color: #4e5764;font-size: 15px;font-weight: 600;margin: 0 auto;display: block;">
                                                                                <div class="pt-4 pb-3">
                                                                                    Sorry We Couldn’t Find Any Matches For <span class="text-danger"></span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </section>
                                                        </div>
                                                    </div>
                        </div>-->
                      </div>
                    </div>

                    <div class="row" v-if="ajaxCallinprogress">
                      <div class="col-lg-12 py-5 px-3">
                        <div class="flex-container">
                          <half-circle-spinner
                            :animation-duration="1000"
                            :size="60"
                            color="#00448b"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="!ajaxCallinprogress && !allAccounts.length">
                      <div class="col-lg-12 text-center py-3 px-3">
                        <img
                          src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/no_business_account.svg"
                          class="img-fluid"
                          style="width: 150px;"
                        />
                        <h5 class="pt-3" style="color: #303031;">No Business Account Found</h5>
                      </div>
                    </div>

                    <div
                      v-else
                      class="connection-section business-employee-box managecompanies-uk-grid-width-small-1-1 managecompanies-uk-grid-width-medium-1-49 managecompanies-uk-grid-width-large-1-49 managecompanies-uk-grid-width-xlarge-1-49 mb-3"
                    >
                      <div class="card-box" v-for="(userAccount,index) in allAccounts" :key="index">
                        <div class="md-card business-employee-card md-card-hover">
                          <div v-if="account == userAccount.company_id" class="d-flex flex-column" style="position: absolute; right: 20px;">
                            <span style="background-color: #d4af37; font-size: 8px; text-align: center; height: 40px; width: 60px; padding-top: 10px;">Primary <br /> Company</span>
                            <div style="width: 0; height: 0; border-left: 30px solid #d4af37; border-right: 30px solid #d4af37; border-bottom: 20px solid transparent;"></div>
                          </div>
                          <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/business-account.png" alt style="width:100%" />
                          <ul class="list-group businessaccountslist" style="margin-top:-10px">
                            <li class="list-group-item three-line">
                              <div class="avatar avatarbusinesslist mt-3">
                                <img
                                  :src="userAccount.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                />
                              </div>
                              <div class="list-item-content">
                                <h4>{{userAccount.company_name}}</h4>
                                <p>
                                  <img src="/static/icons/crm/earth-globe.svg" alt />
                                  &nbsp;
                                  {{userAccount.email_id}}
                                </p>
                                <!-- <p>hubertblainewolfes@digicollect.com</p> -->
                                <div class="buttonsview mb-3 mt-3" style="height: 30px;">
                                  <button
                                    class="btn btn-whitebr-outline mr-3"
                                    :disabled="account == userAccount.company_id"
                                    @click="switchAccount(userAccount.company_id, index)"
                                  >Switch</button>
                                  <button
                                    class="btn btn-whitebr-outline"
                                    @click="goToAccount(userAccount.company_id)"
                                  >View</button>
                                </div>
                              </div>
                              <!-- <div class="secondary-container" v-if="account == userAccount.company_id"  style="color: #fff;position: absolute;right: 16px;">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/crm/is_active.svg" alt="Comapny Active" style="width: 14px;" class="mr-2"> Active
                              </div>-->
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { HalfCircleSpinner } from "epic-spinners";
import globals from "./globals";
export default {
  data() {
    return {
      allAccounts: [],
      ajaxCallinprogress: false,
      //showIllustrator: false
    };
  },
  components: {
    HalfCircleSpinner,
  },
  methods: {
    // Redirection to Company Set Up Page
    accountSetup() {
      this.$router.push({ path: "/setup" });
    },

    // Redirecting to Company Profile Page
    goToAccount(company_id) {
      this.$router.push({ path: "/companyprofile/" + company_id });
    },

    // Switching Account Between Companies and Set Token
    switchAccount(account_id, index) {
      if (account_id != null) {
        this.$http
          .post("/change_account", { account_id: account_id })
          .then(res => {
            //this.showIllustrator = true;
            if (res.data.status_id == 1) {
              this.$cookie.set("Token", res.data.Authorization, {
                expires: 7,
                domain: "digicollect.com",
              });
              axios.defaults.headers.common.Authorization = this.$cookie.get(
                "Token"
              );
              window.location.reload();
            }
          });
      } else {
        this.$http.get("/change_account").then(res => {
          //this.showIllustrator = true;
          if (res.data.status_id == 1) {
            this.$cookie.set("Token", res.data.Authorization, {
              expires: 7,
              domain: "digicollect.com",
            });
            axios.defaults.headers.common.Authorization = this.$cookie.get(
              "Token"
            );
            window.location.reload();
          }
        });
      }
      //this.showIllustrator = false;
    },

    // Logout function
    logout() {
      this.$cookie.delete("Token", { domain: "digicollect.com" });
      window.location.href =
        globals.AUTH_URL + "?redirect_to=" + window.location;
    },

    // Get Created Companies
    getUserCompanines() {
      this.ajaxCallinprogress = true;
      this.$http.get("/employees/get_user_companies").then(res => {
        if (res.data.status_id == 1) {
          this.allAccounts = res.data.response;
          // localStorage.allAccounts = JSON.stringify(res.data.response);
          // this.allAccounts = (JSON.parse(localStorage.allAccounts));
          this.ajaxCallinprogress = false;
        }
      });
    },
  },
  computed: {
    loggedInUser() {
      return this.$store.state.loggedInUser;
    },
    isBusinessAccount() {
      return this.$store.state.isBusinessAccount;
    },
    account() {
      return this.$store.state.account;
    },
    selectedCompany() {
      return this.$store.state.selectedCompany;
    },
  },
  created() {
    this.getUserCompanines();
  },
};
</script>
<style>
.buttonsview {
  display: none;
}
.md-card.business-employee-card.md-card-hover:hover .buttonsview {
  display: inline-block;
}
.managecompanies-uk-grid {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.managecompanies-uk-grid:after,
.managecompanies-uk-grid:before {
  content: "";
  display: block;
  overflow: hidden;
}
.managecompanies-uk-grid:after {
  clear: both;
}
.managecompanies-uk-grid > * {
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  margin: 0;
  float: left;
}
.managecompanies-uk-grid > * > :last-child {
  margin-bottom: 0;
}
.managecompanies-uk-grid {
  margin-left: -25px;
}
.managecompanies-uk-grid > * {
  padding-left: 25px;
}
.managecompanies-uk-grid + .managecompanies-uk-grid,
.managecompanies-uk-grid-margin,
.managecompanies-uk-grid
  > *
  > .managecompanies-uk-panel
  + .managecompanies-uk-panel {
  margin-top: 25px;
}
@media (min-width: 1220px) {
  .managecompanies-uk-grid {
    margin-left: -35px;
  }
  .managecompanies-uk-grid > * {
    padding-left: 35px;
  }
  .managecompanies-uk-grid + .managecompanies-uk-grid,
  .managecompanies-uk-grid-margin,
  .managecompanies-uk-grid
    > *
    > .managecompanies-uk-panel
    + .managecompanies-uk-panel {
    margin-top: 35px;
  }
}
.managecompanies-uk-grid-collapse {
  margin-left: 0;
}
.managecompanies-uk-grid-collapse > * {
  padding-left: 0;
}
.managecompanies-uk-grid-collapse + .managecompanies-uk-grid-collapse,
.managecompanies-uk-grid-collapse
  > *
  > .managecompanies-uk-panel
  + .managecompanies-uk-panel,
.managecompanies-uk-grid-collapse > .managecompanies-uk-grid-margin {
  margin-top: 0;
}
.managecompanies-uk-grid-small {
  margin-left: -10px;
}
.managecompanies-uk-grid-small > * {
  padding-left: 10px;
}
.managecompanies-uk-grid-small + .managecompanies-uk-grid-small,
.managecompanies-uk-grid-small
  > *
  > .managecompanies-uk-panel
  + .managecompanies-uk-panel,
.managecompanies-uk-grid-small > .managecompanies-uk-grid-margin {
  margin-top: 10px;
}
.managecompanies-uk-grid-medium {
  margin-left: -25px;
}
.managecompanies-uk-grid-medium > * {
  padding-left: 25px;
}
.managecompanies-uk-grid-medium + .managecompanies-uk-grid-medium,
.managecompanies-uk-grid-medium
  > *
  > .managecompanies-uk-panel
  + .managecompanies-uk-panel,
.managecompanies-uk-grid-medium > .managecompanies-uk-grid-margin {
  margin-top: 25px;
}
@media (min-width: 960px) {
  .managecompanies-uk-grid-large {
    margin-left: -35px;
  }
  .managecompanies-uk-grid-large > * {
    padding-left: 35px;
  }
  .managecompanies-uk-grid-large + .managecompanies-uk-grid-large,
  .managecompanies-uk-grid-large-margin,
  .managecompanies-uk-grid-large
    > *
    > .managecompanies-uk-panel
    + .managecompanies-uk-panel {
    margin-top: 35px;
  }
}
@media (min-width: 1220px) {
  .managecompanies-uk-grid-large {
    margin-left: -50px;
  }
  .managecompanies-uk-grid-large > * {
    padding-left: 50px;
  }
  .managecompanies-uk-grid-large + .managecompanies-uk-grid-large,
  .managecompanies-uk-grid-large-margin,
  .managecompanies-uk-grid-large
    > *
    > .managecompanies-uk-panel
    + .managecompanies-uk-panel {
    margin-top: 50px;
  }
}
.managecompanies-uk-grid-divider:not(:empty) {
  margin-left: -25px;
  margin-right: -25px;
}
.managecompanies-uk-grid-divider > * {
  padding-left: 25px;
  padding-right: 25px;
}
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-9-"]:nth-child(n + 2),
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-1-"]:not(.managecompanies-uk-width-1-1):nth-child(n
    + 2),
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-2-"]:nth-child(n + 2),
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-3-"]:nth-child(n + 2),
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-4-"]:nth-child(n + 2),
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-5-"]:nth-child(n + 2),
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-6-"]:nth-child(n + 2),
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-7-"]:nth-child(n + 2),
.managecompanies-uk-grid-divider
  > [class*="managecompanies-uk-width-8-"]:nth-child(n + 2) {
  border-left: 1px solid #ddd;
}
@media (min-width: 768px) {
  .managecompanies-uk-grid-divider
    > [class*="managecompanies-uk-width-medium-"]:not(.managecompanies-uk-width-medium-1-1):nth-child(n
      + 2) {
    border-left: 1px solid #ddd;
  }
}
@media (min-width: 960px) {
  .managecompanies-uk-grid-divider
    > [class*="managecompanies-uk-width-large-"]:not(.managecompanies-uk-width-large-1-1):nth-child(n
      + 2) {
    border-left: 1px solid #ddd;
  }
}
@media (min-width: 1220px) {
  .managecompanies-uk-grid-divider:not(:empty) {
    margin-left: -35px;
    margin-right: -35px;
  }
  .managecompanies-uk-grid-divider > * {
    padding-left: 35px;
    padding-right: 35px;
  }
  .managecompanies-uk-grid-divider:empty {
    margin-top: 35px;
    margin-bottom: 35px;
  }
}
.managecompanies-uk-grid-divider:empty {
  margin-top: 25px;
  margin-bottom: 25px;
  border-top: 1px solid #ddd;
}
.managecompanies-uk-grid-match > * {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.managecompanies-uk-grid-match > * > * {
  -ms-flex: none;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 100%;
}
/* [class*=managecompanies-uk-grid-width]>*{
    box-sizing:border-box;
    width:100%
} */
.managecompanies-uk-grid-width-1-2 > * {
  width: 50%;
}
.managecompanies-uk-grid-width-1-3 > * {
  width: 33.333%;
}
.managecompanies-uk-grid-width-1-4 > * {
  width: 25%;
}
.managecompanies-uk-grid-width-1-5 > * {
  width: 20%;
}
.managecompanies-uk-grid-width-1-6 > * {
  width: 16.666%;
}
.managecompanies-uk-grid-width-1-10 > * {
  width: 10%;
}
.managecompanies-uk-grid-width-auto > * {
  width: auto;
}
@media (min-width: 480px) {
  .managecompanies-uk-grid-width-small-1-1 > * {
    width: 100%;
  }
  .managecompanies-uk-grid-width-small-1-2 > * {
    width: 50%;
  }
  .managecompanies-uk-grid-width-small-1-3 > * {
    width: 33.333%;
  }
  .managecompanies-uk-grid-width-small-1-4 > * {
    width: 25%;
  }
  .managecompanies-uk-grid-width-small-1-5 > * {
    width: 20%;
  }
  .managecompanies-uk-grid-width-small-1-6 > * {
    width: 16.666%;
  }
  .managecompanies-uk-grid-width-small-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 768px) {
  .managecompanies-uk-grid-width-medium-1-1 > * {
    width: 100%;
  }
  .managecompanies-uk-grid-width-medium-1-2 > * {
    width: 50%;
  }
  .managecompanies-uk-grid-width-medium-1-49 > * {
    width: 50%;
  }
  .managecompanies-uk-grid-width-medium-1-3 > * {
    width: 33.333%;
  }
  .managecompanies-uk-grid-width-medium-1-4 > * {
    width: 25%;
  }
  .managecompanies-uk-grid-width-medium-1-5 > * {
    width: 20%;
  }
  .managecompanies-uk-grid-width-medium-1-6 > * {
    width: 16.666%;
  }
  .managecompanies-uk-grid-width-medium-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 960px) {
  .managecompanies-uk-grid-width-large-1-1 > * {
    width: 100%;
  }
  .managecompanies-uk-grid-width-large-1-2 > * {
    width: 50%;
  }
  .managecompanies-uk-grid-width-large-1-49 > * {
    width: 49%;
  }
  .managecompanies-uk-grid-width-large-1-3 > * {
    width: 33.333%;
  }
  .managecompanies-uk-grid-width-large-1-4 > * {
    width: 25%;
  }
  .managecompanies-uk-grid-width-large-1-32 > * {
    width: 32%;
  }
  .managecompanies-uk-grid-width-large-1-5 > * {
    width: 20%;
  }
  .managecompanies-uk-grid-width-large-1-6 > * {
    width: 16.666%;
  }
  .managecompanies-uk-grid-width-large-1-10 > * {
    width: 10%;
  }
}
@media (min-width: 1220px) {
  .managecompanies-uk-grid-width-xlarge-1-1 > * {
    width: 100%;
  }
  .managecompanies-uk-grid-width-xlarge-1-2 > * {
    width: 50%;
  }
  .managecompanies-uk-grid-width-xlarge-1-2 > * {
    width: 49%;
  }
  .managecompanies-uk-grid-width-xlarge-1-3 > * {
    width: 33.333%;
  }
  .managecompanies-uk-grid-width-xlarge-1-4 > * {
    width: 25%;
  }
  .managecompanies-uk-grid-width-xlarge-1-5 > * {
    width: 20%;
  }
  .managecompanies-uk-grid-width-xlarge-1-24 > * {
    width: 24%;
  }
  .managecompanies-uk-grid-width-xlarge-1-6 > * {
    width: 16.666%;
  }
  .managecompanies-uk-grid-width-xlarge-1-16 > * {
    width: 16% !important;
  }
  .managecompanies-uk-grid-width-xlarge-1-10 > * {
    width: 10%;
  }
}
[class*="managecompanies-uk-width"] {
  box-sizing: border-box;
  width: 100%;
}
.managecompanies-uk-width-1-1 {
  width: 100%;
}
.managecompanies-uk-width-1-2,
.managecompanies-uk-width-2-4,
.managecompanies-uk-width-3-6,
.managecompanies-uk-width-5-10 {
  width: 50%;
}
.managecompanies-uk-width-1-3,
.managecompanies-uk-width-2-6 {
  width: 33.333%;
}
.managecompanies-uk-width-2-3,
.managecompanies-uk-width-4-6 {
  width: 66.666%;
}
.managecompanies-uk-width-1-4 {
  width: 25%;
}
.managecompanies-uk-width-3-4 {
  width: 75%;
}
.managecompanies-uk-width-1-5,
.managecompanies-uk-width-2-10 {
  width: 20%;
}
.managecompanies-uk-width-2-5,
.managecompanies-uk-width-4-10 {
  width: 40%;
}
.managecompanies-uk-width-3-5,
.managecompanies-uk-width-6-10 {
  width: 60%;
}
.managecompanies-uk-width-4-5,
.managecompanies-uk-width-8-10 {
  width: 80%;
}
.managecompanies-uk-width-1-6 {
  width: 16.666%;
}
.managecompanies-uk-width-5-6 {
  width: 83.333%;
}
.managecompanies-uk-width-1-10 {
  width: 10%;
}
.managecompanies-uk-width-3-10 {
  width: 30%;
}
.managecompanies-uk-width-7-10 {
  width: 70%;
}
.managecompanies-uk-width-9-10 {
  width: 90%;
}
@media (min-width: 480px) {
  .managecompanies-uk-width-small-1-1 {
    width: 100%;
  }
  .managecompanies-uk-width-small-1-2,
  .managecompanies-uk-width-small-2-4,
  .managecompanies-uk-width-small-3-6,
  .managecompanies-uk-width-small-5-10 {
    width: 50%;
  }
  .managecompanies-uk-width-small-1-3,
  .managecompanies-uk-width-small-2-6 {
    width: 33.333%;
  }
  .managecompanies-uk-width-small-2-3,
  .managecompanies-uk-width-small-4-6 {
    width: 66.666%;
  }
  .managecompanies-uk-width-small-1-4 {
    width: 25%;
  }
  .managecompanies-uk-width-small-3-4 {
    width: 75%;
  }
  .managecompanies-uk-width-small-1-5,
  .managecompanies-uk-width-small-2-10 {
    width: 20%;
  }
  .managecompanies-uk-width-small-2-5,
  .managecompanies-uk-width-small-4-10 {
    width: 40%;
  }
  .managecompanies-uk-width-small-3-5,
  .managecompanies-uk-width-small-6-10 {
    width: 60%;
  }
  .managecompanies-uk-width-small-4-5,
  .managecompanies-uk-width-small-8-10 {
    width: 80%;
  }
  .managecompanies-uk-width-small-1-6 {
    width: 16.666%;
  }
  .managecompanies-uk-width-small-5-6 {
    width: 83.333%;
  }
  .managecompanies-uk-width-small-1-10 {
    width: 10%;
  }
  .managecompanies-uk-width-small-3-10 {
    width: 30%;
  }
  .managecompanies-uk-width-small-7-10 {
    width: 70%;
  }
  .managecompanies-uk-width-small-9-10 {
    width: 90%;
  }
}
@media (min-width: 768px) {
  .managecompanies-uk-width-medium-1-1 {
    width: 100%;
  }
  .managecompanies-uk-width-medium-1-2,
  .managecompanies-uk-width-medium-2-4,
  .managecompanies-uk-width-medium-3-6,
  .managecompanies-uk-width-medium-5-10 {
    width: 50%;
  }
  .managecompanies-uk-width-medium-1-3,
  .managecompanies-uk-width-medium-2-6 {
    width: 33.333%;
  }
  .managecompanies-uk-width-medium-2-3,
  .managecompanies-uk-width-medium-4-6 {
    width: 66.666%;
  }
  .managecompanies-uk-width-medium-1-4 {
    width: 25%;
  }
  .managecompanies-uk-width-medium-3-4 {
    width: 75%;
  }
  .managecompanies-uk-width-medium-1-5,
  .managecompanies-uk-width-medium-2-10 {
    width: 20%;
  }
  .managecompanies-uk-width-medium-2-5,
  .managecompanies-uk-width-medium-4-10 {
    width: 40%;
  }
  .managecompanies-uk-width-medium-3-5,
  .managecompanies-uk-width-medium-6-10 {
    width: 60%;
  }
  .managecompanies-uk-width-medium-4-5,
  .managecompanies-uk-width-medium-8-10 {
    width: 80%;
  }
  .managecompanies-uk-width-medium-1-6 {
    width: 16.666%;
  }
  .managecompanies-uk-width-medium-5-6 {
    width: 83.333%;
  }
  .managecompanies-uk-width-medium-1-10 {
    width: 10%;
  }
  .managecompanies-uk-width-medium-3-10 {
    width: 30%;
  }
  .managecompanies-uk-width-medium-7-10 {
    width: 70%;
  }
  .managecompanies-uk-width-medium-9-10 {
    width: 90%;
  }
}
@media (min-width: 960px) {
  .managecompanies-uk-width-large-1-1 {
    width: 100%;
  }
  .managecompanies-uk-width-large-1-2,
  .managecompanies-uk-width-large-2-4,
  .managecompanies-uk-width-large-3-6,
  .managecompanies-uk-width-large-5-10 {
    width: 50%;
  }
  .managecompanies-uk-width-large-1-3,
  .managecompanies-uk-width-large-2-6 {
    width: 33.333%;
  }
  .managecompanies-uk-width-large-2-3,
  .managecompanies-uk-width-large-4-6 {
    width: 66.666%;
  }
  .managecompanies-uk-width-large-1-4 {
    width: 25%;
  }
  .managecompanies-uk-width-large-3-4 {
    width: 75%;
  }
  .managecompanies-uk-width-large-1-5,
  .managecompanies-uk-width-large-2-10 {
    width: 20%;
  }
  .managecompanies-uk-width-large-2-5,
  .managecompanies-uk-width-large-4-10 {
    width: 40%;
  }
  .managecompanies-uk-width-large-3-5,
  .managecompanies-uk-width-large-6-10 {
    width: 60%;
  }
  .managecompanies-uk-width-large-4-5,
  .managecompanies-uk-width-large-8-10 {
    width: 80%;
  }
  .managecompanies-uk-width-large-1-6 {
    width: 16.666%;
  }
  .managecompanies-uk-width-large-5-6 {
    width: 83.333%;
  }
  .managecompanies-uk-width-large-1-10 {
    width: 10%;
  }
  .managecompanies-uk-width-large-3-10 {
    width: 30%;
  }
  .managecompanies-uk-width-large-7-10 {
    width: 70%;
  }
  .managecompanies-uk-width-large-9-10 {
    width: 90%;
  }
}
@media (min-width: 1220px) {
  .managecompanies-uk-width-xlarge-1-1 {
    width: 100%;
  }
  .managecompanies-uk-width-xlarge-1-2,
  .managecompanies-uk-width-xlarge-2-4,
  .managecompanies-uk-width-xlarge-3-6,
  .managecompanies-uk-width-xlarge-5-10 {
    width: 50%;
  }
  .managecompanies-uk-width-xlarge-1-3,
  .managecompanies-uk-width-xlarge-2-6 {
    width: 33.333%;
  }
  .managecompanies-uk-width-xlarge-2-3,
  .managecompanies-uk-width-xlarge-4-6 {
    width: 66.666%;
  }
  .managecompanies-uk-width-xlarge-1-4 {
    width: 25%;
  }
  .managecompanies-uk-width-xlarge-3-4 {
    width: 75%;
  }
  .managecompanies-uk-width-xlarge-1-5,
  .managecompanies-uk-width-xlarge-2-10 {
    width: 20%;
  }
  .managecompanies-uk-width-xlarge-2-5,
  .managecompanies-uk-width-xlarge-4-10 {
    width: 40%;
  }
  .managecompanies-uk-width-xlarge-3-5,
  .managecompanies-uk-width-xlarge-6-10 {
    width: 60%;
  }
  .managecompanies-uk-width-xlarge-4-5,
  .managecompanies-uk-width-xlarge-8-10 {
    width: 80%;
  }
  .managecompanies-uk-width-xlarge-1-6 {
    width: 16.666%;
  }
  .managecompanies-uk-width-xlarge-5-6 {
    width: 83.333%;
  }
  .managecompanies-uk-width-xlarge-1-10 {
    width: 10%;
  }
  .managecompanies-uk-width-xlarge-3-10 {
    width: 30%;
  }
  .managecompanies-uk-width-xlarge-7-10 {
    width: 70%;
  }
  .managecompanies-uk-width-xlarge-9-10 {
    width: 90%;
  }
}
@media (min-width: 768px) {
  [class*="managecompanies-uk-push-"],
  [class*="managecompanies-uk-pull-"] {
    position: relative;
  }
  .managecompanies-uk-push-1-2,
  .managecompanies-uk-push-2-4,
  .managecompanies-uk-push-3-6,
  .managecompanies-uk-push-5-10 {
    left: 50%;
  }
  .managecompanies-uk-push-1-3,
  .managecompanies-uk-push-2-6 {
    left: 33.333%;
  }
  .managecompanies-uk-push-2-3,
  .managecompanies-uk-push-4-6 {
    left: 66.666%;
  }
  .managecompanies-uk-push-1-4 {
    left: 25%;
  }
  .managecompanies-uk-push-3-4 {
    left: 75%;
  }
  .managecompanies-uk-push-1-5,
  .managecompanies-uk-push-2-10 {
    left: 20%;
  }
  .managecompanies-uk-push-2-5,
  .managecompanies-uk-push-4-10 {
    left: 40%;
  }
  .managecompanies-uk-push-3-5,
  .managecompanies-uk-push-6-10 {
    left: 60%;
  }
  .managecompanies-uk-push-4-5,
  .managecompanies-uk-push-8-10 {
    left: 80%;
  }
  .managecompanies-uk-push-1-6 {
    left: 16.666%;
  }
  .managecompanies-uk-push-5-6 {
    left: 83.333%;
  }
  .managecompanies-uk-push-1-10 {
    left: 10%;
  }
  .managecompanies-uk-push-3-10 {
    left: 30%;
  }
  .managecompanies-uk-push-7-10 {
    left: 70%;
  }
  .managecompanies-uk-push-9-10 {
    left: 90%;
  }
  .managecompanies-uk-pull-1-2,
  .managecompanies-uk-pull-2-4,
  .managecompanies-uk-pull-3-6,
  .managecompanies-uk-pull-5-10 {
    left: -50%;
  }
  .managecompanies-uk-pull-1-3,
  .managecompanies-uk-pull-2-6 {
    left: -33.333%;
  }
  .managecompanies-uk-pull-2-3,
  .managecompanies-uk-pull-4-6 {
    left: -66.666%;
  }
  .managecompanies-uk-pull-1-4 {
    left: -25%;
  }
  .managecompanies-uk-pull-3-4 {
    left: -75%;
  }
  .managecompanies-uk-pull-1-5,
  .managecompanies-uk-pull-2-10 {
    left: -20%;
  }
  .managecompanies-uk-pull-2-5,
  .managecompanies-uk-pull-4-10 {
    left: -40%;
  }
  .managecompanies-uk-pull-3-5,
  .managecompanies-uk-pull-6-10 {
    left: -60%;
  }
  .managecompanies-uk-pull-4-5,
  .managecompanies-uk-pull-8-10 {
    left: -80%;
  }
  .managecompanies-uk-pull-1-6 {
    left: -16.666%;
  }
  .managecompanies-uk-pull-5-6 {
    left: -83.333%;
  }
  .managecompanies-uk-pull-1-10 {
    left: -10%;
  }
  .managecompanies-uk-pull-3-10 {
    left: -30%;
  }
  .managecompanies-uk-pull-7-10 {
    left: -70%;
  }
  .managecompanies-uk-pull-9-10 {
    left: -90%;
  }
}
.managecompanies-uk-panel {
  display: block;
  position: relative;
}
.managecompanies-uk-panel,
.managecompanies-uk-panel:hover {
  text-decoration: none;
}
.managecompanies-uk-panel:after,
.managecompanies-uk-panel:before {
  content: "";
  display: table;
}
.managecompanies-uk-panel:after {
  clear: both;
}
.managecompanies-uk-panel > :not(.managecompanies-uk-panel-title):last-child {
  margin-bottom: 0;
}
.managecompanies-uk-panel-title {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  text-transform: none;
  color: #444;
}
.managecompanies-uk-panel-badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}
.managecompanies-uk-panel-teaser {
  margin-bottom: 15px;
}
.managecompanies-uk-panel-body {
  padding: 15px;
}
.managecompanies-uk-panel-box {
  padding: 15px;
  background: #fafafa;
  color: #444;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.managecompanies-uk-panel-box-hover:hover {
  color: #444;
}
.managecompanies-uk-panel-box .managecompanies-uk-panel-title {
  color: #444;
}
.managecompanies-uk-panel-box .managecompanies-uk-panel-badge {
  top: 10px;
  right: 10px;
}
.managecompanies-uk-panel-box > .managecompanies-uk-panel-teaser {
  margin-top: -16px;
  margin-left: -16px;
  margin-right: -16px;
}
.managecompanies-uk-panel-box > .managecompanies-uk-nav-side {
  margin: 0 -15px;
}
.managecompanies-uk-panel-box-primary {
  background-color: #ebf7fd;
  color: #2d7091;
  border-color: rgba(45, 112, 145, 0.3);
}
.managecompanies-uk-panel-box-primary-hover:hover {
  color: #2d7091;
}
.managecompanies-uk-panel-box-primary .managecompanies-uk-panel-title {
  color: #2d7091;
}
.managecompanies-uk-panel-box-secondary {
  background-color: #fff;
  color: #444;
}
.managecompanies-uk-panel-box-secondary-hover:hover {
  color: #444;
}
.managecompanies-uk-panel-box-secondary .managecompanies-uk-panel-title {
  color: #444;
}
.managecompanies-uk-panel-hover {
  padding: 15px;
  color: #444;
  border: 1px solid transparent;
  border-radius: 4px;
}
.managecompanies-uk-panel-hover:hover {
  background: #fafafa;
  color: #444;
  border-color: #ddd;
}
.managecompanies-uk-panel-hover .managecompanies-uk-panel-badge {
  top: 10px;
  right: 10px;
}
.managecompanies-uk-panel-hover > .managecompanies-uk-panel-teaser {
  margin-top: -16px;
  margin-left: -16px;
  margin-right: -16px;
}
.managecompanies-uk-panel-header .managecompanies-uk-panel-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
  color: #444;
}
.managecompanies-uk-panel-space {
  padding: 30px;
}
.managecompanies-uk-panel-space .managecompanies-uk-panel-badge {
  top: 30px;
  right: 30px;
}
.managecompanies-uk-panel + .managecompanies-uk-panel-divider {
  margin-top: 50px !important;
}
.managecompanies-uk-panel + .managecompanies-uk-panel-divider:before {
  content: "";
  display: block;
  position: absolute;
  top: -25px;
  left: 0;
  right: 0;
  border-top: 1px solid #ddd;
}
@media (min-width: 1220px) {
  .managecompanies-uk-panel + .managecompanies-uk-panel-divider {
    margin-top: 70px !important;
  }
  .managecompanies-uk-panel + .managecompanies-uk-panel-divider:before {
    top: -35px;
  }
}
.managecompanies-uk-panel-box .managecompanies-uk-panel-teaser {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}
.managecompanies-uk-block {
  position: relative;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (min-width: 768px) {
  .managecompanies-uk-block {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
.managecompanies-uk-block:after,
.managecompanies-uk-block:before {
  content: "";
  display: table;
}
.managecompanies-uk-block:after {
  clear: both;
}
.managecompanies-uk-block > :last-child {
  margin-bottom: 0;
}
.managecompanies-uk-block-large {
  padding-top: 20px;
  padding-bottom: 20px;
}
@media (min-width: 768px) {
  .managecompanies-uk-block-large {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
@media (min-width: 960px) {
  .managecompanies-uk-block-large {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
.managecompanies-uk-block-default {
  background: #fff;
}
.managecompanies-uk-block-muted {
  background: #f9f9f9;
}
.managecompanies-uk-block-primary {
  background: #00a8e6;
}
.managecompanies-uk-block-secondary {
  background: #222;
}
.managecompanies-uk-block-default + .managecompanies-uk-block-default,
.managecompanies-uk-block-muted + .managecompanies-uk-block-muted,
.managecompanies-uk-block-primary + .managecompanies-uk-block-primary,
.managecompanies-uk-block-secondary + .managecompanies-uk-block-secondary {
  padding-top: 0;
}
.md-card.business-employee-card {
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  margin-top: 10px !important;
}
.md-card.business-employee-card + .md-card.business-employee-card,
.md-card.business-employee-card + .managecompanies-uk-grid,
.managecompanies-uk-grid + .md-card.business-employee-card {
  margin-top: 25px;
}
.md-card.business-employee-card .full_width_in_card {
  padding: 16px 24px;
  background: rgba(0, 0, 0, 0.085);
}
.md-card.business-employee-card .md-card-toolbar {
  height: 48px;
  padding: 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
}
.md-card.business-employee-card .md-card-toolbar:after,
.md-card.business-employee-card .md-card-toolbar:before {
  content: " ";
  display: table;
}
.md-card.business-employee-card .md-card-toolbar:after {
  clear: both;
}
.md-card.business-employee-card .md-card-toolbar:after,
.md-card.business-employee-card .md-card-toolbar:before {
  content: " ";
  display: table;
}
.md-card.business-employee-card .md-card-toolbar:after {
  clear: both;
}
.md-card.business-employee-card .md-card-toolbar-heading-text {
  font: 500 14px/50px Roboto, sans-serif;
  color: #212121;
  margin: 0;
  float: left;
  overflow: hidden;
  height: 48px;
}
.md-card.business-employee-card .md-card-toolbar-heading-text.large {
  font-size: 18px;
  font-weight: 400;
}
.md-card.business-employee-card .md-card-toolbar .md-toggle-group {
  float: left;
  margin: 8px 0 0 16px;
}
.md-card.business-employee-card
  .md-card-toolbar
  .md-toggle-group.md-toggle-group-small {
  margin-top: 10px;
}
.md-card.business-employee-card .md-card-toolbar .md-card-toolbar-actions {
  float: right;
  padding-top: 10px;
}
.md-card.business-employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .managecompanies-uk-open
  .md-card-toolbar-icon {
  background: rgba(0, 0, 0, 0.085);
  color: #212121;
}
.md-card.business-employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .md-card-dropdown {
  display: inline-block;
  position: relative;
}
.md-card.business-employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control {
  min-width: 220px;
  margin-top: -3px;
}
.md-card.business-employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control
  .selectize-input {
  min-height: 30px;
  padding: 4px 8px;
}
.md-card.business-employee-card
  .md-card-toolbar
  .md-card-toolbar-actions
  .selectize-control
  .selectize-dropdown {
  margin-top: -34px;
}
.md-card.business-employee-card .md-card-toolbar .md-icon + .md-card-dropdown {
  margin-left: 4px;
}
.md-card.business-employee-card
  .md-card-toolbar
  .md-card-fullscreen-deactivate {
  margin: 9px 8px 0 0;
}
.md-card.business-employee-card .md-card-toolbar-input {
  border: none;
  font: 400 18px/24px Roboto, sans-serif;
  height: auto;
  background: 0 0 !important;
  padding: 12px 0;
  width: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.business-employee-card .md-card-toolbar .managecompanies-uk-tab {
  margin-top: -2px;
  border-bottom: none;
}
.md-card.business-employee-card
  .md-card-toolbar
  .managecompanies-uk-tab
  li
  > a {
  padding: 10px 8px !important;
}
.md-card.business-employee-card .md-card-head {
  height: 200px;
  position: relative;
  border-bottom: 1px solid transparent;
}
.md-card.business-employee-card .md-card-head-menu {
  position: absolute;
  right: 8px;
  top: 8px;
  border: 1px solid #e0e3e6;
  border-radius: 4px;
  background: #fff;
}
.profile-img-div {
  background-color: rgba(255, 255, 255, 0);
  width: 86px;
  height: 86px;
  border-radius: 50%;
  margin-top: 20px;
  display: inline-block;
  border: 2px solid;
}
.md-card.business-employee-card .md-card-head-avatar {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  margin-top: 4px;
  display: inline-block;
}
.md-card.business-employee-card .md-card-head-text {
  padding: 20px 10px 8px;
  font-size: 15px;
  color: #00448b;
  margin: 0;
  font-weight: 600;
  line-height: 1.19;
}
.md-card.business-employee-card .md-card-head-text span:not(.listNavSelector) {
  display: block;
  font-size: 13px;
  margin-top: 5px;
  margin-bottom: 0px;
  color: #00448b;
  font-weight: 400;
  line-height: 1.25;
}
.md-card.business-employee-card .md-card-head-text.text_dark {
  color: #303031 !important;
}
.md-card.business-employee-card .md-card-head-text-over {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 0.65)),
    to(rgba(0, 0, 0, 0))
  );
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.65) 0,
    rgba(0, 0, 0, 0) 100%
  );
}
.md-card.business-employee-card .md-card-head-subtext {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 0 16px;
  text-align: right;
  color: #fff;
}
.md-card.business-employee-card .md-card-head-subtext span {
  font-size: 26px;
}
.md-card.business-employee-card .md-card-head-icon {
  font-size: 48px;
  color: #fff;
  vertical-align: middle;
}
.md-card.business-employee-card .md-card-head.head_background {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-bottom-color: transparent;
}
.md-card.business-employee-card
  .md-card-head.head_background
  .md-card-head-text {
  color: #fff;
}
.md-card.business-employee-card .md-card-head.head_background_top {
  background-repeat: no-repeat;
  background-position: center top;
}
.md-card.business-employee-card .md-card-head.head_background_bottom {
  background-repeat: no-repeat;
  background-position: center bottom;
}
.md-card.business-employee-card .md-card-head .head_chart {
  height: 100px;
  width: 100%;
  position: absolute !important;
  left: 0;
  top: 40px;
}
.md-card.business-employee-card .md-card-head .fitVid_player {
  width: 100%;
  height: 160px;
  overflow: hidden;
}
.md-card.business-employee-card .md-card-head-img {
  height: 100%;
  width: auto;
}
.md-card.business-employee-card .md-card-head iframe {
  height: 160px;
}
.md-card.business-employee-card .md-card-content {
  padding: 5px 12px 12px;
}
.md-card.business-employee-card .md-card-content.padding-reset {
  padding: 0;
}
.md-card.business-employee-card .md-card-content.large-padding {
  padding: 24px 35px;
}
.md-card.business-employee-card .md-card-content.small-padding {
  padding: 8px;
}
.md-card.md-card-fullscreen-activate {
  cursor: pointer;
}
.md-card.md-card-fullscreen {
  position: fixed;
  z-index: 9998;
  overflow-x: hidden;
  cursor: default;
}
.md-card.md-card-fullscreen .md-card-fullscreen-activate {
  display: none;
}
.md-card.md-card-fullscreen .md-card-fullscreen-hide {
  display: none;
}
.md-card.business-employee-card .md-card-fullscreen-content {
  display: none;
  padding: 16px;
}
.md-card-fullscreen-content-hidden
  .md-card.business-employee-card
  .md-card-fullscreen-content {
  display: block;
  visibility: hidden;
  padding: 0;
}
.md-card.mdToolbar_fixed {
  overflow-y: hidden;
}
.md-card.mdToolbar_fixed > .md-card-toolbar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
  -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
    0 3px 6px rgba(0, 0, 0, 0.23);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.md-card.mdToolbar_fixed > .md-card-content {
  overflow-y: scroll;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  top: 48px;
  bottom: 0;
}
.md-card.mdToolbar_fixed > .md-card-content .md-card-fullscreen-content {
  padding: 16px 0;
}
.md-card.business-employee-card.md-card-overlay {
  overflow: hidden;
  padding-bottom: 54px;
}
.md-card.business-employee-card .md-card-overlay .md-card-content {
  height: 142px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.business-employee-card .md-card-overlay .md-card-content.no_truncate {
  position: relative;
}
.md-card.business-employee-card.md-card-overlay
  .md-card-content.no_truncate:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 8px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(50%, #fff),
    to(rgba(255, 255, 255, 0))
  );
  background-image: linear-gradient(
    to top,
    #fff 50%,
    rgba(255, 255, 255, 0) 100%
  );
  display: block;
  content: "";
  z-index: 10;
}
.md-card.business-employee-card.md-card-overlay .md-card-content > pre {
  margin-top: 0;
  max-height: 110px;
}
.md-card.business-employee-card.md-card-overlay .md-card-content > pre > code {
  overflow: hidden;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-content {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  padding: 0 16px;
  margin-top: -54px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  text-align: left;
  bottom: 0;
  background: #fff;
  z-index: 10;
  -webkit-transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-content p {
  margin: 0;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-content p + * {
  margin-top: 16px;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-content p + p {
  margin-top: 4px;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header {
  padding: 12px 0;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header:after,
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header:before {
  content: " ";
  display: table;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header:after {
  clear: both;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header:after,
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header:before {
  content: " ";
  display: table;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header:after {
  clear: both;
}
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header h3,
.md-card.business-employee-card.md-card-overlay .md-card-overlay-header h4 {
  margin: 0;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  padding-right: 32px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card.business-employee-card.md-card-overlay
  .md-card-overlay-header
  .md-icon {
  position: absolute;
  right: 12px;
  top: 11px;
}
.md-card.business-employee-card.md-card-overlay-active
  .md-card-overlay-content {
  top: -1px;
  margin-top: 0;
}
/* .md-card.md-card-hover{
    -webkit-transition:all 280ms cubic-bezier(.4,0,.2,1);
    transition:all 280ms cubic-bezier(.4,0,.2,1);
    will-change:box-shadow
}
.md-card.md-card-hover:hover{
    -webkit-box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);
    box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)
} */
.managecompanies-uk-sortable-dragged .md-card {
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.managecompanies-uk-sortable-dragged .md-card.business-employee-card canvas {
  margin: 0 auto;
  display: block;
}
.md-card.business-employee-card .heading_list {
  padding: 0;
}
.md-card-danger,
.md-card-primary,
.md-card-success,
.md-card-warning {
  border-left: 4px solid transparent;
}
.md-card-primary {
  border-left-color: #00448b;
}
.md-card-success {
  border-left-color: #7cb342;
}
.md-card-danger {
  border-left-color: #e53935;
}
.md-card-warning {
  border-left-color: #ffa000;
}
.md-card-horizontal {
  position: relative;
  min-height: 200px;
}
.md-card-horizontal:after,
.md-card-horizontal:before {
  content: " ";
  display: table;
}
.md-card-horizontal:after {
  clear: both;
}
.md-card-horizontal:after,
.md-card-horizontal:before {
  content: " ";
  display: table;
}
.md-card-horizontal:after {
  clear: both;
}
.md-card-horizontal-grid {
  min-height: auto;
}
.md-card-horizontal .md-card-head {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom: none;
  width: 200px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}
@media only screen and (max-width: 767px) {
  .md-card-horizontal .md-card-head {
    width: 140px;
  }
}
.md-card-horizontal .md-card-head-grid {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.md-card-horizontal .md-card-head-menu {
  right: auto;
  left: 8px;
}
.md-card-horizontal .md-card-content {
  margin-left: 200px;
}
@media only screen and (max-width: 767px) {
  .md-card-horizontal .md-card-content {
    margin-left: 140px;
  }
}
.md-card-horizontal .md-card-content-grid {
  padding: 16px;
}
.md-expand,
.md-expand-group > * {
  opacity: 0;
}
.md-card-placeholder {
  min-width: 100%;
}
.md-card-list-wrapper,
.md-card-list-wrapper *,
.md-card-list-wrapper :after,
.md-card-list-wrapper :before,
.md-card-list-wrapper:after,
.md-card-list-wrapper:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-card-list-wrapper .md-card-list-header {
  position: absolute;
  top: -24px;
  left: 0;
}
.md-card-list-wrapper .md-card-list {
  margin: 48px 0 0 0;
  position: relative;
}
.md-card-list-wrapper .md-card-list:first-child {
  margin-top: 24px;
}
.md-card-list-wrapper .md-card-list > ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.md-card-list-wrapper .md-card-list > ul > li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.md-card-list-wrapper .md-card-list > ul > li {
  min-height: 34px;
  padding: 8px 16px;
  font-size: 13px;
  -webkit-transition: background 150ms, padding 0.2s;
  transition: background 150ms, padding 0.2s;
  background: #fff;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.md-card-list-wrapper .md-card-list > ul > li:after,
.md-card-list-wrapper .md-card-list > ul > li:before {
  content: " ";
  display: table;
}
.md-card-list-wrapper .md-card-list > ul > li:after {
  clear: both;
}
.md-card-list-wrapper .md-card-list > ul > li:after,
.md-card-list-wrapper .md-card-list > ul > li:before {
  content: " ";
  display: table;
}
.md-card-list-wrapper .md-card-list > ul > li:after {
  clear: both;
}
.md-card-list-wrapper .md-card-list > ul > li.item-shown {
  background: #fff;
  padding: 8px 36px;
}
@media only screen and (max-width: 767px) {
  .md-card-list-wrapper
    .md-card-list
    > ul
    > li.item-shown
    .md-card-list-item-subject {
    clear: both;
    float: none;
    padding-top: 16px;
  }
  .md-card-list-wrapper
    .md-card-list
    > ul
    > li.item-shown
    .md-card-list-item-subject
    > span {
    white-space: normal;
  }
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown
  .md-card-list-item-sender {
  width: auto;
  overflow: hidden;
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown.md-card-list-item-selected {
  position: relative;
}
.md-card-list-wrapper
  .md-card-list
  > ul
  > li.item-shown.md-card-list-item-selected:before {
  content: "";
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background: #e3f2fd;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
.md-card-list-wrapper .md-card-list .md-card-list-item-select,
.md-card-list-wrapper .md-card-list .md-card-list-item-sender {
  float: left;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-select {
  padding: 6px 8px 0 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
.md-card-list-wrapper .md-card-list .md-card-list-item-date,
.md-card-list-wrapper .md-card-list .md-card-list-item-sender,
.md-card-list-wrapper .md-card-list .md-card-list-item-subject {
  padding: 0 8px;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  .md-card-list-item-avatar {
  background: #757575;
  color: #fff;
  width: 34px;
  border-radius: 50%;
  display: block;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  .md-card-list-item-avatar-large {
  width: 82px;
  border-radius: 50%;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-avatar-wrapper
  span.md-card-list-item-avatar {
  line-height: 34px;
  text-transform: uppercase;
  text-align: center;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-sender {
  width: 220px;
  line-height: 34px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-sender > span {
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
@media only screen and (max-width: 1219px) {
  .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
    display: none;
  }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject {
  overflow: hidden;
  font-weight: 500;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-subject > span {
  line-height: 34px;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-subject
  .md-card-list-item-sender-small {
  display: none;
}
@media only screen and (max-width: 1219px) {
  .md-card-list-wrapper
    .md-card-list
    .md-card-list-item-subject
    .md-card-list-item-sender-small {
    display: block;
  }
  .md-card-list-wrapper
    .md-card-list
    .md-card-list-item-subject
    .md-card-list-item-sender-small
    + span {
    line-height: inherit;
  }
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-subject
  .md-card-list-item-sender-small
  > span {
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  font-size: 12px;
  color: #999;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-date {
  line-height: 34px;
  float: right;
  color: #999;
}
@media only screen and (max-width: 479px) {
  .md-card-list-wrapper .md-card-list .md-card-list-item-date {
    display: none;
  }
}
.md-card-list-wrapper .md-card-list .md-card-list-item-menu {
  float: right;
  margin: 0 0 0 8px;
  position: relative;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-menu
  .managecompanies-uk-dropdown
  .material-icons {
  margin-right: 8px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content-wrapper {
  display: none;
  clear: both;
  opacity: 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-content {
  padding: 16px 16px 0 0;
  max-height: 360px;
  overflow-x: hidden;
  margin: 0 0 40px;
  top: 20px;
  position: relative;
  font-size: 14px;
}
.md-card-list-wrapper
  .md-card-list
  .md-card-list-item-content
  + .md-card-list-item-reply {
  padding-top: 10px;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-reply {
  padding: 16px 0;
}
.md-card-list-wrapper .md-card-list .md-card-list-item-selected {
  background: #e3f2fd;
}
.md-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.md-list > li {
  padding: 0;
  margin: 0;
  list-style: none;
}
.md-list,
.md-list *,
.md-list :after,
.md-list :before,
.md-list:after,
.md-list:before {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.md-list .managecompanies-uk-nestable-list > li,
.md-list > li {
  min-height: 48px;
  padding: 8px 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  position: relative;
}
.md-list .managecompanies-uk-nestable-list > li > .md-list-content,
.md-list > li > .md-list-content {
  overflow: hidden;
}
.md-list .managecompanies-uk-nestable-list > li > .md-list-content > span,
.md-list > li > .md-list-content > span {
  display: block;
}
.md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-content
  .md-list-heading,
.md-list > li > .md-list-content .md-list-heading {
  margin: 0;
  font-weight: 500;
  display: block;
  overflow: hidden;
  padding-bottom: 1px;
}
.md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-content
  .md-list-menu,
.md-list > li > .md-list-content .md-list-menu {
  float: right;
}
.md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-content
  .md-list-menu
  .md-list-menu-toggle,
.md-list > li > .md-list-content .md-list-menu .md-list-menu-toggle {
  display: block;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
  width: 28px;
  height: 28px;
  line-height: 28px;
  border-radius: 14px;
  text-align: center;
}
.md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-content
  .managecompanies-uk-badge,
.md-list > li > .md-list-content .managecompanies-uk-badge {
  float: right;
  color: #fff !important;
}
.md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-content
  .md-list-action,
.md-list > li > .md-list-content .md-list-action {
  float: right;
  margin-left: 8px;
  margin-top: 2px;
  display: none;
}
.md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-content
  .md-list-action-placeholder,
.md-list > li > .md-list-content .md-list-action-placeholder {
  float: right;
  margin-left: 8px;
  display: none;
  width: 32px;
  height: 32px;
}
.md-list .managecompanies-uk-nestable-list > li .md-list-action-dropdown,
.md-list > li .md-list-action-dropdown {
  position: absolute;
  right: 16px;
  top: 10px;
  display: none;
}
.md-list .managecompanies-uk-nestable-list > li > a.md-list-content,
.md-list > li > a.md-list-content {
  display: block;
  color: #212121;
}
.md-list .managecompanies-uk-nestable-list > li:last-child,
.md-list > li:last-child {
  border-bottom: none;
}
.md-list .managecompanies-uk-nestable-list > li.md-list-item-active,
.md-list > li.md-list-item-active {
  color: #7cb342;
  background: #ededed;
}
.md-list
  .managecompanies-uk-nestable-list
  > li.md-list-item-disabled
  > .md-list-content,
.md-list > li.md-list-item-disabled > .md-list-content {
  color: #bdbdbd;
}
.md-list
  .managecompanies-uk-nestable-list
  > li.md-list-item-disabled
  > .md-list-content
  span,
.md-list > li.md-list-item-disabled > .md-list-content span {
  color: #bdbdbd !important;
}
.md-list .managecompanies-uk-nestable-list > li.heading_list,
.md-list > li.heading_list {
  min-height: 32px;
  padding: 32px 8px 16px;
  border-bottom: none;
  background: 0 0 !important;
  text-transform: uppercase;
}
.md-list
  .managecompanies-uk-nestable-list
  > li:hover
  > .md-list-addon-element
  .managecompanies-uk-nestable-handle,
.md-list
  > li:hover
  > .md-list-addon-element
  .managecompanies-uk-nestable-handle,
.managecompanies-uk-touch
  .md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-addon-element
  .managecompanies-uk-nestable-handle,
.managecompanies-uk-touch
  .md-list
  > li
  > .md-list-addon-element
  .managecompanies-uk-nestable-handle {
  display: block;
}
.md-list
  .managecompanies-uk-nestable-list
  > li:hover
  > .md-list-content
  .md-list-action,
.md-list
  .managecompanies-uk-nestable-list
  > li:hover
  > .md-list-content
  .md-list-action-placeholder,
.md-list > li:hover > .md-list-content .md-list-action,
.md-list > li:hover > .md-list-content .md-list-action-placeholder,
.managecompanies-uk-touch
  .md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-content
  .md-list-action,
.managecompanies-uk-touch
  .md-list
  .managecompanies-uk-nestable-list
  > li
  > .md-list-content
  .md-list-action-placeholder,
.managecompanies-uk-touch .md-list > li > .md-list-content .md-list-action,
.managecompanies-uk-touch
  .md-list
  > li
  > .md-list-content
  .md-list-action-placeholder {
  display: block;
}
.md-list .managecompanies-uk-nestable-list > li:hover .md-list-action-dropdown,
.md-list > li:hover .md-list-action-dropdown,
.managecompanies-uk-touch
  .md-list
  .managecompanies-uk-nestable-list
  > li
  .md-list-action-dropdown,
.managecompanies-uk-touch .md-list > li .md-list-action-dropdown {
  display: block;
}
.md-list .managecompanies-uk-nestable-list > li {
  margin-left: 64px;
}
.md-list-addon > li {
  margin-left: 64px;
  position: relative;
}
.md-list-addon > li:last-child .md-list-addon-element {
  border-bottom: none;
  bottom: 0;
}
.md-list-addon > li:first-child .md-list-addon-element {
  top: 0;
}
.md-list-addon > li.md-list-item-active .md-list-addon-element,
.md-list-addon > li.md-list-item-active .md-list-addon-element .material-icons {
  color: #7cb342;
}
.md-list-addon-element {
  position: absolute;
  left: -64px;
  top: -1px;
  bottom: -1px;
  width: 64px;
  text-align: center;
  padding: 8px 0;
  display: block;
}
.md-list-addon-element .element-status {
  position: absolute;
  right: 12px;
  top: 10px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #bdbdbd;
  border: 1px solid #fff;
}
.md-list-addon-element .element-status-danger {
  background: #e53935;
}
.md-list-addon-element .element-status-success {
  background: #7cb342;
}
.md-list-addon-element .element-status-warning {
  background: #ffa000;
}
.md-list-addon-element > .md-list-addon-avatar {
  margin-top: 2px;
}
.md-list-addon-element > .md-list-addon-icon {
  font-size: 28px;
  margin-top: 4px;
  color: #727272;
}
.md-list-addon-element > .material-icons {
  margin-top: 6px;
}
.md-list-addon-element .icheckbox_md,
.md-list-addon-element .iradio_md {
  margin-top: 10px;
}
.md-list-addon-element .managecompanies-uk-nestable-handle {
  position: absolute;
  left: -2px;
  top: 12px;
  display: none;
}
.md-list-interactive li {
  cursor: pointer;
}
.md-list-bg {
  background: #fff;
}
.md-list-separated li {
  background: #fff;
  padding: 8px;
}
.md-list-separated li + li {
  border-top: none;
  margin-top: 8px;
}
.md-list-bg-no-sep {
  background: #fff;
  padding: 8px;
}
.md-list-bg-no-sep li > .md-list-content {
  padding: 0 4px;
}
.md-list-outside > li {
  padding: 0;
}
.md-list-outside > li > .md-list-content {
  padding: 8px 16px;
  display: block;
  color: #212121;
}
.md-list-outside > li.md-list-item-active,
.md-list-outside > li:hover:not(.heading_list) {
  background: rgba(0, 0, 0, 0.085);
}
.md-list-outside > li.heading_list {
  padding: 32px 16px 16px;
}
.md-list-outside.md-list-addon li {
  margin-left: 0;
}
.md-list-outside.md-list-addon li .md-list-addon-element {
  position: relative;
  top: auto;
  left: auto;
  float: left;
}
.md-list-outside.md-list-addon li .md-list-content {
  padding-left: 0;
}
.md-list-outside-wrapper {
  position: relative;
}
.md-list-outside-wrapper .md-list-outside-search {
  position: absolute;
  top: -46px;
  left: 16px;
  right: 16px;
  z-index: 1000;
}
.md-list-outside-wrapper .md-list-outside-search .md-input-wrapper {
  padding: 0;
}
.md-list-outside-wrapper
  .md-list-outside-search
  .md-input-wrapper
  .md-input-bar:after,
.md-list-outside-wrapper
  .md-list-outside-search
  .md-input-wrapper
  .md-input-bar:before {
  background: #fff;
}
.md-list-outside-wrapper .md-list-outside-search .md-input {
  border-bottom-color: transparent !important;
}
.md-list .managecompanies-uk-nestable-list {
  padding-left: 0;
}
.md-list .managecompanies-uk-nestable-list .managecompanies-uk-nestable-item {
  padding-right: 0;
}
.md-list .managecompanies-uk-nestable-item + .managecompanies-uk-nestable-item {
  margin-top: 0;
}
.md-list-right.md-list-addon > li {
  margin-left: 0;
  margin-right: 64px;
}
.md-list-right.md-list-addon > li .md-list-addon-element {
  left: auto;
  right: -64px;
}
.managecompanies-uk-touch
  .md-list-addon-element
  .managecompanies-uk-nestable-handle {
  display: block !important;
}
.managecompanies-uk-touch .md-list-content .md-list-action,
.managecompanies-uk-touch .md-list-content .md-list-action-placeholder {
  display: block !important;
}
.managecompanies-uk-touch .md-list-action-dropdown {
  display: block !important;
}

.business-employee-box {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 370px));
  gap: 4rem;
  width: 100%;
  padding: 0 8px;
  justify-content: space-evenly;
}
.card-box {
  width: 100%;
}
.pink-box {
  box-shadow: 0 2px 10px 0 rgba(255, 38, 138, 0.55);
  background-color: #ff268a;
}
.blue-box {
  box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
  background-color: #00448b;
}
.lightblue-box {
  box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
  background-color: #50bcff;
}
.orange-box {
  box-shadow: 0 2px 10px 0 rgba(245, 166, 35, 0.35);
  background-color: #f5a623;
}
.border-orange1 {
  border-color: #ff7f00 !important;
}
.border-green1 {
  border-color: #1a9347 !important;
}
.border-red1 {
  border-color: #e82828 !important;
}
.border-blue1 {
  border-color: #00448b !important;
}
.card-group {
  margin-bottom: 2.143rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.card-block {
  position: relative;
  padding: 1.429rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}
.card.card-block {
  box-shadow: none;
}
@media (min-width: 480px) {
  .card-group {
    -webkit-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
  }
  .card-group .card:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group .card {
    margin-bottom: 0;
    -webkit-box-flex: 1;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
  }
}
.counter {
  text-align: center;
}
.vertical-align:before {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.vertical-align-bottom,
.vertical-align-middle {
  display: inline-block;
  max-width: 100%;
  font-size: 1rem;
}
.vertical-align-middle {
  vertical-align: middle;
}
.counter-lg .counter-icon {
  font-size: 40px;
}
.counter-inverse .counter-icon {
  color: #00448b;
}
.counter-inverse {
  color: #303031;
}
.h-150 {
  height: 150px !important;
}
.modal-qr-block {
  width: 100%;
  position: relative;
  display: block;
  padding: 20px 10px 0px;
  text-align: center;
}
.modal-passport-block {
  width: 100%;
  position: relative;
  display: block;
  padding: 5px 10px 0px;
}
.option__image {
  max-height: 80px;
  margin-right: 10px;
}
.option__desc,
.option__image {
  display: inline-block;
  vertical-align: middle;
}
.option__desc {
  padding: rem(10px);
}
.option__title {
  font-size: rem(24px);
}
.option__small {
  margin-top: rem(10px);
  display: block;
}
.form__label {
  margin-top: 5px !important;
}
.badge__img {
  vertical-align: middle;
  float: right;
}
.badge__name {
  vertical-align: middle;
  margin-left: 5px;
  float: left;
}
.connection-section {
  text-align: left;
  padding-top: 0px;
  padding-bottom: 20px;
  padding-left: 20px;
}
.connection-section {
  font-weight: bold;
  line-height: 1.22;
  color: #303031;
  margin-top: 0px;
  margin-bottom: 30px;
}
.see-link {
  text-decoration: underline;
  font-size: 13px;
  font-weight: normal;
  line-height: 1.2;
  color: #00448b;
  cursor: pointer;
  float: right;
}
.btn-outline-danger:hover {
  color: #fff !important;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-outline-danger {
  color: #f44336 !important;
  background-color: transparent;
  background-image: none;
  border-color: #f44336;
}
.btn-secondary.btn-outline {
  color: #00448b !important;
  background-color: transparent;
  background-image: none;
  border: 1px solid #00448b;
}
.btn-secondary.btn-outline:hover {
  color: #fff !important;
  background-color: #00448b;
  border-color: #00448b;
}
.btn-outline-default:hover,
.btn-outline-default:active {
  color: #fff !important;
  background-color: #4e5764;
  border-color: #4e5764;
}
.btn-outline-default {
  color: #4e5764 !important;
  background-color: transparent;
  background-image: none;
  border-color: #4e5764;
}
.nav-pills.connection-employees .nav-link {
  -webkit-border-radius: 18px;
  border-radius: 18px;
}
.nav-pills.connection-employees .nav-link {
  height: 32px;
  color: #00448b;
  text-decoration: none;
  border: 1px solid #00448b;
  line-height: 32px;
  margin-right: 10px;
  background-color: #fff;
}
/* .nav-pills.connection-employees .nav-link:hover,
.nav-pills.connection-employees .nav-link:focus {
    text-decoration: none;
    color: #fff !important;
    background-color: #00448b;
} */
.tab-content.employee-tab-content {
  padding: 10px 0px;
}
.employeeSearch {
  overflow-y: auto;
  min-height: 100px;
  max-height: 300px;
  overflow-x: hidden;
}
.employeeSearchResult {
  overflow-y: auto;
  min-height: 75px;
  max-height: 300px;
  overflow-x: hidden;
}
.employeeSearch .contact {
  min-height: 60px;
}

.employeeSearch .contact:last-child {
  margin-bottom: 40px;
}
.avatar.avatar-grey {
  background-color: #cdd2da;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 0.28px;
  color: #ffffff;
  width: 40px !important;
  min-width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
}
.input-search-rounded-box-employee {
  position: relative;
}
.input-search-rounded-box-employee .input-search-close,
.input-search-rounded-box-employee .input-search-icon {
  position: absolute;
  top: 50%;
  z-index: 1;
  width: 2.573rem;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}
.input-search-rounded-box-employee .input-search-icon {
  left: 2px;
  font-size: 24px;
  color: #9e9e9e;
  text-align: center;
  pointer-events: none;
}
.input-search-rounded-box-employee .input-search-icon + .form-control {
  padding-left: 38px !important;
}
.input-search-rounded-box-employee .form-control {
  border-radius: 0px !important;
}
.input-search-close.icon {
  font-size: inherit !important;
  line-height: inherit !important;
}
button.input-search-close {
  -webkit-appearance: none !important;
  padding: 0 !important;
  cursor: pointer !important;
  background: 0 0 !important;
  border: 0 !important;
}
.input-search-rounded-box-employee .input-search-close {
  right: 8px !important;
  color: #cdd2da !important;
  font-size: 21px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}
.input-search-rounded-box-employee .form-control {
  height: 34px !important;
  -webkit-appearance: none !important;
  border-color: #e0e0e0 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  -moz-appearance: none !important;
}
.input-search-rounded-box-employee .form-control {
  display: block !important;
  width: 100% !important;
  padding: 0.429rem 1.072rem !important;
  font-size: 14px !important;
  line-height: 1.571429 !important;
  color: #4e5764 !important;
  background-color: #fff !important;
  border: 0px;
  border-bottom: solid 1px #00448b !important;
}
.input-search-rounded-box-employee .form-control:focus {
  border-bottom: solid 1px #00448b !important;
}
.searchfooter {
  height: 40px;
  box-shadow: 0 -3px 4px 0 rgba(0, 0, 0, 0.16);
  background-color: #e5e5e5;
  line-height: 40px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.51px;
  color: #fff;
  display: block;
  position: absolute;
  bottom: 0px;
  width: 100%;
}
.searchfooter:hover {
  color: #00448b;
}
.search-user-employee-blocks {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.employeeSearch .contact .search-user-employee-blocks .mailtext,
.employeeSearch .contact .search-user-employee-blocks .user-employee-name {
  width: 200px;
}

.searchTitle {
  top: 0px;
  position: relative;
}

.dropdown-employee {
  width: 420px;
  min-height: 100px;
  max-height: 390px;
  margin: 0.25rem 0 0 !important;
  overflow-y: auto;
  border-radius: 11px !important;
  padding: 0rem 0 !important;
  position: absolute;
  left: -20px !important;
  z-index: 99;
  cursor: pointer;
  box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.dropdown-employee-search {
  width: 420px;
  min-height: 72px;
  max-height: 390px;
  margin: 0.25rem 0 0 !important;
  overflow-y: auto;
  border-radius: 11px !important;
  padding: 0rem 0 !important;
  position: absolute;
  left: -20px !important;
  z-index: 99;
  cursor: pointer;
  box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.dropdown-toggle.employee-toggle.pointer.btn.btn-link:hover i {
  background-color: #00448b;
  color: #fff;
  border-radius: 50%;
  border: 1px solid #00448b;
}
.dropdown-toggle.employee-toggle.pointer.btn.btn-link:active i {
  background-color: #00448b;
  color: #fff;
  border-radius: 50%;
  border: 1px solid #00448b;
}
.searchContentEmployee {
  background-color: transparent;
  color: #00448b;
  font-size: 30px;
  width: 32px;
  height: 32px;
  line-height: 30px;
  border: 1px solid transparent;
}
.dropdown-toggle.employee-toggle::after {
  content: none !important;
}
.page-header-search {
  height: 5.6rem;
  min-height: 5.6rem;
  max-height: 5.6rem;
}
.list-group.dense.managecompanyheader .list-group-item > .avatar.avatar-header {
  border: 5px solid #cdd2da;
  width: 70px;
  max-width: 70px;
  height: 70px;
  margin-top: 0px;
}
.list-group.dense.managecompanyheader
  .list-group-item
  > .avatar.avatar-header
  img {
  width: 66px;
  height: 66px;
  max-width: 66px;
  max-height: 66px;
  border-radius: 50%;
}
.list-group.managecompanyheader .list-group-item h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #303031;
}
.list-group.managecompanyheader .list-group-item h4 {
  font-size: 1.3rem;
  font-weight: 400;
  margin: 5px 0 6px 0;
  font-size: 13px;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #4e5764;
}
.list-group.managecompanyheader .list-group-item p {
  font-size: 1.3rem;
  font-weight: 500;
  margin: 0;
}
.list-group.managecompanyheader .list-group-item button.btn-log {
  width: 20px !important;
}
.list-group.managecompanyheader
  .list-group-item.three-line
  > .secondary-container {
  margin-top: 14px !important;
}
.btn-md {
  border-radius: 6px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}
.list-group.businessaccountslist .list-group-item > .avatar.avatarbusinesslist {
  border: 2px solid #fff !important;
  width: 70px;
  max-width: 70px;
  height: 70px;
  margin-top: -54px !important;
  margin-right: 0px !important;
  max-height: 70px;
  background-color: transparent !important;
  line-height: 70px !important;
  position: absolute;
}
.list-group.businessaccountslist
  .list-group-item
  > .avatar.avatarbusinesslist
  img {
  max-width: 60px;
  max-height: 60px;
  border-radius: 50%;
  width: 60px;
  height: 60px;
}
.list-group.businessaccountslist .list-group-item h3 {
  margin: 4px 0px 0px 0px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #fff;
}
.list-group.businessaccountslist .list-group-item h4 {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 5px 0 6px 0;
  font-size: 14px;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #fff;
  max-width: 350px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-group.businessaccountslist .list-group-item p {
  font-weight: 400;
  margin: 0;
  font-size: 13px;
  line-height: 1.21;
  letter-spacing: 0.6px;
  color: #fff;
}
.list-group.businessaccountslist .list-group-item button.btn-log {
  width: 20px !important;
}
.list-group.businessaccountslist .list-group-item {
  border-radius: 0 0 10px 10px !important;
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: linear-gradient(to bottom, #005dae, #29c2e0) !important;
}
.list-group.businessaccountslist .list-group-item.three-line {
  min-height: 12.9rem !important;
}
.list-group.businessaccountslist
  .list-group-item.three-line
  > .secondary-container {
  margin-top: 0px !important;
}
.list-group.businessaccountslist .list-group-item > .list-item-content {
  margin-top: 2.5em;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.businessHeader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 40px;
  position: relative;
  background: #d6e2ef;
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 4px;
}

.businessHeader > .descriptionheader {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 8px 14px;
  border-bottom: 1px solid transparent;
}

.businessHeader > .descriptionheader .description-text-header-left h5 {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  color: #000000;
}

.businessHeader > .descriptionheader .description-text-header-right {
  font-size: 13px;
  margin-left: auto;
  padding-left: 12px;
  color: #00448b;
  font-weight: 500;
}

.businessHeader > .descriptionheader .description-text-header-right {
  display: block;
}

.businessHeader > .descriptionheader .description-text-header-right i {
  color: #00448b;
  font-size: 30px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ManageCompany.vue